export enum EStockFileType {
    IMAGE = 'image',
    VIDEO = 'video'
}
